import React, { useEffect, useState, useCallback } from 'react';

import { Redirect } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import { useQuery } from '@tanstack/react-query';

import LoadingSpinner from './../MySurveys/LoadingSpinner';
import styles from './ProviderTransactions.module.css';
import TransactionsTabs from './TransactionsTabs';

import { isV2PermissionsEnabled } from '../../helpers/featureFlags/isV2PermissionsEnabled';
import { useProviderRbac } from '../../hooks/useProviderRbac';
import { ROLE, useHasAnyRole } from '../../utils/permissions';
import { protectApiViaOkta } from '../../utils/protectApiViaOkta';
import { APPLICATION_HEADERS, API_URLS } from '../common/headers';
import Tooltip from '../common/Tooltip/Tooltip';
import Layout from '../Layout/ProviderLayout';

const ProviderTransactions = () => {
  let teamName = '';

  if (!isV2PermissionsEnabled()) {
    const res = JSON.parse(sessionStorage.getItem('USER_DATA'));

    if (res && res['Team Name']) {
      teamName = res['Team Name'];
    }
  }

  const { providerNameRbac } = useProviderRbac();

  const providerName = isV2PermissionsEnabled() ? providerNameRbac : teamName;

  const { data: providerTransactions, isFetching } = useQuery({
    queryKey: ['providerTransactions', providerName],
    queryFn: async () => {
      try {
        const URL = `${API_URLS.myTransactionAnalytics}?providername=` + providerName;
        const res = await protectApiViaOkta('get', URL);

        if (res.status === 200) {
          const data = res.data?.list;

          return data;
        }
      } catch (error) {
        console.error('Error fetching provider transactions:', error);
      }
    },
    enabled: !!providerName,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  let userHasAccess = false;

  const { hasRoles } = useHasAnyRole([ROLE.BASIC_PROVIDER, ROLE.ADVANCED_PROVIDER]);

  if (isV2PermissionsEnabled()) {
    userHasAccess = hasRoles;
  }

  return !userHasAccess && isV2PermissionsEnabled() ? (
    <Redirect to="/locations/place/-78.549668/39.014/7" />
  ) : (
    <Layout>
      <div className="pageContainer">
        <div className="dashboardDiv">
          <div className="dashboard-heading dashboard-heading-transactions">
            <h3>My Transactions</h3>
            <Tooltip text="View your performance of transactions from CBRE" />
          </div>
          <div className="dashboard-content">
            {isFetching && (
              <div className={styles.spinner__container}>
                <LoadingSpinner />
              </div>
            )}
            {providerTransactions && providerTransactions.length > 0 && (
              <Grid classes={{ root: styles.dashboard__grid }}>
                <TransactionsTabs providerData={providerTransactions} providerName={providerName} />
              </Grid>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProviderTransactions;
